import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import LineItemsInformation from "../../Components/Schedule/LineItems";
import SchedulingTech from "../../Components/Schedule/SchedulingTech";
import ScheduleVerification from "../../Components/Schedule/Verification";
import SchedulePayment from "../../Components/Schedule/PaymentMethod";
import Modal from "../../Components/Schedule/Modal";
import {RescheduleConfirm} from "../../Components/Schedule/RescheduleConfirm";
import useGetJobs from "../../Global/Api/Jobs/getJobs.api";
import useCreateJob from "../../Global/Api/Schedule/createJobApi";
import {setActiveJob} from "../../Store/Slice/jobsSlice";
import {
  clearState,
  setRescheduleConfirmModal,
  setSendData,
  setScheduleStep,
  setTechnician,
  setTotalTimeAction, setTotalPriceAction
} from "../../Store/Slice/scheduleSlice";
import ScheduleFinish from "../../Components/Schedule/Finish";
import {useParams} from "react-router-dom";
import moment from "moment";
import "./index.scss";

export default function Schedule() {
  const { reschedule } = useCreateJob();
  const dispatch = useDispatch();
  const Jobs = useGetJobs({ allList: false });
  const {title: jobTitle} = useParams();
  const [showModal, setShowModal] = useState(false);
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
  const {rescheduleConfirmModal} = useSelector((state) => state.rootReducer.scheduleSlice);
  const accountData = useSelector((state) => state.rootReducer.techsbookSlice.userData);
  const [isDatePast, setIsDatePast] = useState(false);
  const scheduledDate = new Date(activeJob?.job_datetime).getTime();
  const currentDate = new Date(new Date().toLocaleString("en-US", { timeZone: activeJob?.job_timezone })).getTime();


  const diffInMs = scheduledDate - currentDate;
  const isDateIn24Hrs = useMemo(() => {
    return (diffInMs > 0 && diffInMs <= 24 * 60 * 60 * 1000);
  }, [activeJob?.job_datetime]);

  useEffect(() => {
    if (activeJob?.job_datetime) {
      const isPast = moment(activeJob?.job_datetime).isBefore(new Date());
      setIsDatePast(isPast);
    }
  }, [activeJob?.job_datetime]);

  const handleModal = () => {setShowModal(!showModal)};
  const handleConfirmModal = () => {dispatch(setRescheduleConfirmModal(false))};
  const fillSendData = async () => {
    if (!jobTitle) return;
    const job = await Jobs.getById(jobTitle);
    if (!job) return;
    const localJobDateTime = job?.job_datetime ? moment(job?.job_datetime, "DD MMM YYYY, hh:mm A").local().format("YYYY-MM-DD HH:mm:ss") : "";
    const totalP = job?.items?.filter(el => Boolean(el?.id !== 0))?.reduce((acc, el) => acc + (el?.qty * el?.price), 0);
    await dispatch(setSendData({
      verification_key: job?.verification_key,
      job_datetime: localJobDateTime,
      job_address: job?.address,
      technician_id: job?.technician?.id,
      technician: job?.technician,
      lat: job?.lat,
      lon: job?.lon,
      has_equipment: job?.has_equipment,
      payment_method_id: job?.payment_method?.id,
      payments: job?.payments,
      verification_text: null,
      affirm_due_days: null,
      description: job?.description,
      job_items: job?.items?.filter(el => Boolean(el?.id !== 0)),
      primary_contact: job?.contacts[0],
      location: {
        lat: job?.lat,
        lon: job?.lon,
        city: job?.city,
        zip: job?.zip_code,
        state: job?.state,
        country: job?.country,
        street: job?.street,
      },
      vehicle_count: job?.vehicle_count,
      tracking_number: job?.tracking_number,
      purchase_order: job?.purchase_order,
      equipment_arrival_date: job?.equipment_arrival_date || null,
      job_timezone: job?.job_timezone,
      millage_round_trip_distance: job?.millage_round_trip_distance
      }));
    dispatch(setTotalTimeAction(job?.time));
    dispatch(setTotalPriceAction(totalP));
    dispatch(setTechnician({
      job_address: {
        address: job?.address,
        lat: job?.lat,
        lon: job?.lon,
      },
      date: JSON.stringify(job?.job_datetime),
      time: job?.job_datetime ? {
        label: `${moment(job?.job_datetime).format("hh:mm A")} - ${moment(job?.job_endtime).format("hh:mm A")}`,
        active: true,
        start: job?.job_datetime,
        end: job?.job_endtime,
      } : null,
      lat: job?.lat,
      lon: job?.lon,
      technician_id: job?.technician,
      technician: job?.technician,
      description: job?.description,
      verification_key: job?.verification_key,
      tracking_number: job?.tracking_number,
      purchase_order: job?.purchase_order,
    }));
  };

  useEffect(() => {
    if(jobTitle){
      fillSendData();
    } else {
      dispatch(setActiveJob({}));
      dispatch(clearState());
      dispatch(setScheduleStep(1));
    }
  }, [jobTitle]);

  const rescheduleTheJob = () => {
    reschedule(jobTitle);
    dispatch(clearState());
    dispatch(setScheduleStep(1));
  };

  return (
    <div className="schedule">
      {showModal ? <Modal handleModal={handleModal} /> : null}
      {rescheduleConfirmModal ? <RescheduleConfirm handleModal={handleConfirmModal} rescheduleTheJob={rescheduleTheJob} /> : null}
      <div className="schedule__a">
        <LineItemsInformation accountData={accountData}/>
        <SchedulingTech />
        <ScheduleVerification />
        {(jobTitle && (!isDateIn24Hrs && !isDatePast)) ? null : <SchedulePayment/>}
      </div>
      <ScheduleFinish />
    </div>
  );
}
